<template>
	<div class="panel-container">
		<div class="panel-header">
			<div class="title">{{ title }}</div>
			<div class="option-checkbox-container" v-if="isShowOptionCheckbox">
				<Checkbox
					:isCheck="isCheckOption"
					:onCheck="onCheckOptionCallback"
					:disabled="isOptionsDisabled"
					:optionText="optionText"
				/>
			</div>
			<div class="collapsible-control" @click="onToggleCollpase" v-if="isShowCollapsible">
				<span class="caret" />
			</div>
		</div>
		<div
			class="panel-body"
			:class="{ collapse: isCollapseToggle }"
			v-show-slide="!isCollapseToggle"
		>
			<slot></slot>
		</div>
	</div>
</template>

<script>
import Checkbox from '@/components/Checkbox.vue'

export default {
	name: 'Panel',
	data() {
		return {
			isCollapseToggle: this.isCollapse,
		}
	},
	props: {
		title: String,
		isShowOptionCheckbox: {
			type: Boolean,
			default: false,
		},
		optionText: String,
		isOptionsDisabled: {
			type: Boolean,
			default: false,
		},
		isCheckOption: {
			type: Boolean,
			default: false,
		},
		isShowCollapsible: {
			type: Boolean,
			default: false,
		},
		isCollapse: {
			type: Boolean,
			default: false,
		},
		onCheckOptionCallback: Function,
	},
	components: {
		Checkbox,
	},
	watch: {
		isCollapse(value) {
			this.isCollapseToggle = value
		},
	},
	methods: {
		onToggleCollpase() {
			this.isCollapseToggle = !this.isCollapseToggle
		},
	},
}
</script>

<style lang="scss" scoped>
.panel-container {
	border: 1px solid #e8e8e8;
	border-radius: 3px;
	margin-bottom: 20px;

	.panel-header {
		align-items: center;
		background-color: #c4c4c4;
		font-size: 16px;
		display: flex;
		line-height: 20px;
		justify-content: space-between;
		padding: 14px 12px;
		position: relative;

		.collapsible-control {
			align-items: center;
			cursor: pointer;
			display: flex;
			justify-content: center;
			transition: background-color 0.3s ease-in-out;
			position: absolute;
			top: 0;
			right: 0;
			width: 24px;
			height: 100%;

			&:hover {
				background-color: #d4d4d4;
			}
		}
	}

	.panel-body {
		background-color: #ffffff;
		font-size: 14px;
		line-height: 18px;
		padding: 24px 16px 32px;
		transition: height 0.3s ease 0s, padding-top 0.3s ease 0s !important;

		&.collapse {
			display: block;
			padding-top: 0;
			padding-bottom: 0;
		}
	}
}
</style>
